import { clearApiCache } from '../offline/swCache'

// Support-Modus des Betreibers („Als Werkstatt einloggen"): die Ziel-Werkstatt lebt in sessionStorage
// (pro Tab, endet mit dem Tab — bewusst NICHT localStorage, ein Support-Einstieg soll nie tagelang kleben).
// Der API-Client hängt an jeden Request den X-Impersonate-Workshop-Id-Header; der Server akzeptiert ihn
// AUSSCHLIESSLICH vom Superadmin (sonst 403 + Audit-Alarm) und auditiert jede Schreib-Mutation.
//
// Start/Stop erzwingen einen VOLLEN Reload (location.assign): der react-query-Cache und der SW-API-Cache
// dürfen niemals Daten zweier Mandanten mischen — ein frischer Boot ist die robuste Variante von qc.clear().

const KEY = 'wf.impersonate.v1'

export interface ImpersonationTarget {
  id: number
  name: string
}

export function impersonationTarget(): ImpersonationTarget | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const t = JSON.parse(raw) as ImpersonationTarget
    return Number.isInteger(t?.id) && t.id > 0 && typeof t?.name === 'string' ? t : null
  } catch {
    return null // Privatmodus/kaputter Eintrag: kein Support-Modus, nie werfen
  }
}

/** Header für den API-Client — leer, wenn kein Support-Modus aktiv ist. */
export function impersonationHeaders(): Record<string, string> {
  const t = impersonationTarget()
  return t ? { 'X-Impersonate-Workshop-Id': String(t.id) } : {}
}

export function startImpersonation(target: ImpersonationTarget): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(target))
  } catch {
    return // Storage gesperrt: ohne Persistenz kein konsistenter Support-Modus → gar nicht starten
  }
  clearApiCache() // Mandantenwechsel: nie den gecachten Datenstand des Betreiber-Kontexts zeigen
  window.location.assign('/overview')
}

export function stopImpersonation(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // sessionStorage nicht verfügbar → es kann auch kein Eintrag existieren
  }
  clearApiCache()
  window.location.assign('/admin')
}
